/**
 * Swatch Hover Grid - Hover image effect for variant swatches on collection pages
 * Loaded conditionally when swatch_hover_collection_enable is true.
 *
 * Reads hover image URLs from a [data-swatch-hover-map] JSON script tag
 * embedded in each product grid item by product-grid-item.liquid.
 *
 * Listens for "swatch:change" custom events dispatched by theme.dev.js swatchClicks().
 * Uses the same fetch → blob → objectURL pattern as swatchClicks() in theme.dev.js.
 *
 * Uses pipelineVendor.$ (jQuery) and pipelineVendor.themeImages for consistency.
 */
(function () {
  "use strict";

  var MAX_RETRIES = 30;

  function boot($, themeImages) {
    function round180(x) {
      return Math.ceil(x / 180) * 180;
    }

    function sizeImageUrl(url, size) {
      var result = themeImages.getSizedImageUrl(url, size);
      if (result) return result;

      // Fallback for formats not supported by vendor.js (webp, avif)
      var match = url.match(/\.(webp|avif)(\?v=\d+)?$/i);
      if (match) {
        var parts = url.split(match[0]);
        return parts[0] + "_" + size + match[0];
      }
      return null;
    }

    function isImageCached(url) {
      var img = new Image();
      img.src = url;
      return img.complete && img.naturalWidth > 0;
    }

    function preloadImage(url) {
      return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () {
          resolve(url);
        };
        img.onerror = function () {
          reject(new Error("Failed to load " + url));
        };
        img.src = url;
      });
    }

    function handleSwatchChange(event) {
      var detail = event.detail;
      if (!detail || !detail.swatchValue || !detail.image) return;

      var $gridItem = $(event.target).closest("[data-grid-item]");
      if (!$gridItem.length) $gridItem = $(event.target);

      var $slideContainer = $gridItem.find("[data-grid-slide]");
      var $gridLink = $gridItem.find("[data-grid-link]");
      if (!$slideContainer.length || !$gridLink.length) return;

      // Read the hover map from the DOM
      var mapEl = $gridItem.find("[data-swatch-hover-map]")[0];
      if (!mapEl) return;

      var hoverMap;
      try {
        hoverMap = JSON.parse(mapEl.textContent);
      } catch (e) {
        return;
      }

      var hoverImageSrc = hoverMap[detail.swatchValue.toLowerCase().trim()];

      if (!hoverImageSrc) {
        $gridLink.removeClass("has-swatch-hover");
        return;
      }

      // Size both image URLs the same way swatchClicks() does
      var dpr = window.devicePixelRatio || 1;
      var width = round180(($slideContainer[0].offsetWidth || 360) * dpr);
      var sizedPrimary = sizeImageUrl(detail.image, width + "x");
      var sizedHover = sizeImageUrl(hoverImageSrc, width + "x");
      console.log("detail.image", detail.image);
      console.log("hoverImageSrc", hoverImageSrc);
      console.log("sizedPrimary", sizedPrimary);
      console.log("sizedHover", sizedHover);

      if (!sizedPrimary || !sizedHover) {
        $gridLink.removeClass("has-swatch-hover");
        return;
      }

      // Find or create child layers (reuse to avoid flash)
      var $primary = $slideContainer.find(
        ".product-grid-item__slide-primary",
      );
      var $hover = $slideContainer.find(".product-grid-item__slide-hover");

      if (!$primary.length) {
        $primary = $(
          '<div class="product-grid-item__slide-primary"></div>',
        );
        $slideContainer.append($primary);
      }
      if (!$hover.length) {
        $hover = $('<div class="product-grid-item__slide-hover"></div>');
        $slideContainer.append($hover);
      }

      // Clear any inline bg set by swatchClicks() on the container itself
      $slideContainer.css("background-image", "");
      $slideContainer.css("background-color", "#fff");

      var primaryCached = isImageCached(sizedPrimary);
      var hoverCached = isImageCached(sizedHover);

      // Primary: cached → apply immediately, otherwise show blurred preview
      if (primaryCached) {
        $primary.removeClass("is-loading");
        $primary.css("background-image", 'url("' + sizedPrimary + '")');
      } else {
        var tinyPrimary = sizeImageUrl(detail.image, "50x");
        if (tinyPrimary) {
          $primary.css("background-image", 'url("' + tinyPrimary + '")');
        }
        $primary.addClass("is-loading");
      }

      // Hover: cached → apply immediately
      if (hoverCached) {
        $hover.css("background-image", 'url("' + sizedHover + '")');
      }

      // If both cached, we're done
      if (primaryCached && hoverCached) {
        $gridLink.addClass("has-swatch-hover");
        return;
      }

      // Preload only the images that aren't cached
      var promises = [];
      var primaryIndex = -1;
      var hoverIndex = -1;

      if (!primaryCached) {
        primaryIndex = promises.length;
        promises.push(preloadImage(sizedPrimary));
      }
      if (!hoverCached) {
        hoverIndex = promises.length;
        promises.push(preloadImage(sizedHover));
      }

      Promise.all(promises)
        .then(function (results) {
          if (primaryIndex >= 0) {
            $primary.css("background-image", 'url("' + results[primaryIndex] + '")');
            $primary.removeClass("is-loading");
          }
          if (hoverIndex >= 0) {
            $hover.css("background-image", 'url("' + results[hoverIndex] + '")');
          }

          $gridLink.addClass("has-swatch-hover");
        })
        .catch(function (error) {
          $primary.removeClass("is-loading");
          console.log("[swatch-hover-grid] Error: " + error);
        });
    }

    document.addEventListener("swatch:change", handleSwatchChange);
  }

  // Poll for pipelineVendor.$ and pipelineVendor.themeImages
  function waitForDeps(attempts) {
    var pv = window.pipelineVendor;
    if (pv && pv.$ && pv.themeImages) {
      boot(pv.$, pv.themeImages);
    } else if (attempts < MAX_RETRIES) {
      setTimeout(function () {
        waitForDeps(attempts + 1);
      }, 100);
    } else {
      console.warn(
        "[swatch-hover-grid] pipelineVendor deps not found after " +
          MAX_RETRIES / 10 +
          "s",
      );
    }
  }
  waitForDeps(0);
})();
